import React from 'react';
import makeLoadable from '@loadable/component';
import RouterLoader from './RouterLoader';
import {routePaths} from './route-paths';

export function loadable(module) {
    return makeLoadable(module, {fallback: <RouterLoader />});
}

const componentsByPath = {};

const routes = routePaths.map(routePath => ({
    ...routePath,
    component: componentsByPath[routePath.path],
}));

export default routes;
